//# sourceMappingURL=checkbox.mjs.map
/// <reference types="./checkbox.d.mts" />
import * as $redraw from "../../../../redraw/redraw.mjs";
import * as $attribute from "../../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $h from "../../../../redraw_dom/redraw/dom/html.mjs";
import * as $css from "../../../../sketch/sketch/css.mjs";
import * as $length from "../../../../sketch/sketch/css/length.mjs";
import { px } from "../../../../sketch/sketch/css/length.mjs";
import * as $h_ from "../../../../sketch_redraw/sketch/redraw/dom/html.mjs";
import * as $colors from "../../../ds/colors.mjs";
import { toList } from "../../../gleam.mjs";

export function label(attrs, children) {
  return $h.label(attrs, children);
}

export function input(attrs) {
  let _pipe = $css.class$(
    toList([
      $css.visibility("hidden"),
      $css.width(px(0)),
      $css.height(px(0)),
      $css.position("fixed"),
      $css.top(px(-100_000)),
    ]),
  );
  return $h_.input(_pipe, attrs);
}

export function checkbox(checked, disabled, attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.width(px(20)),
      $css.height(px(20)),
      $css.transition("background .3s, border-color .3s"),
      $css.background(
        (() => {
          if (disabled) {
            if (checked) {
              return $colors.light.grey_800;
            } else {
              return $colors.light.grey_200;
            }
          } else if (checked) {
            return $colors.light.text_display;
          } else {
            return $colors.light.text_white;
          }
        })(),
      ),
      $css.border_width(px(1)),
      $css.border_style("solid"),
      $css.border_color(
        (() => {
          if (checked) {
            return $colors.light.text_display;
          } else {
            return $colors.light.grey_400;
          }
        })(),
      ),
      $css.border_radius(px(6)),
      $css.display("flex"),
      $css.align_items("center"),
      $css.justify_content("center"),
      $css.cursor(
        (() => {
          if (disabled) {
            return "default";
          } else {
            return "pointer";
          }
        })(),
      ),
    ]),
  );
  return $h_.div(_pipe, attrs, children);
}

export function icon(child) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.align_items("center"),
      $css.justify_content("center"),
      $css.width(px(14)),
      $css.height(px(14)),
      $css.color($colors.light.text_white),
    ]),
  );
  return $h_.div(_pipe, toList([]), toList([child]));
}
